var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 65 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8219 52.3664L9.45922 54.3104L2.83789 42.5331L8.35122 36.7304V29.8811L2.83789 23.0318L9.68722 12.1051L18.1352 13.8238L23.6139 11.1598L24.9846 3.01709H39.8246L41.5246 9.74242L47.1299 13.8238L55.5619 12.1051L62.1992 23.7171L56.0339 30.1091L56.2632 35.5891L62.1992 42.5331L55.3499 54.3104L47.5872 52.4838L41.6512 55.2238L39.1392 63.4424H24.9846L22.9606 56.8224",
    stroke: "currentcolor",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2935 33.2299C46.2935 40.8379 40.1268 47.0046 32.5188 47.0046C24.9108 47.0046 18.7441 40.8379 18.7441 33.2299C18.7441 25.6219 24.9108 19.4552 32.5188 19.4552C40.1268 19.4552 46.2935 25.6219 46.2935 33.2299Z",
    stroke: "currentcolor",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.1c02b231963605c1bd99d9072a7d5f1a.svg";
export { ForwardRef as ReactComponent };